import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type {
  GroundingCommandBarOverflowMenuSlots,
  GroundingCommandBarOverflowMenuState,
} from './GroundingCommandBarOverflowMenu.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const GroundingCommandBarOverflowMenuClassNames: SlotClassNames<GroundingCommandBarOverflowMenuSlots> = {
  root: 'fai-GroundingCommandBarOverflowMenu',
  menuTrigger: 'fai-GroundingCommandBarOverflowMenu__menuTrigger',
  menuButton: 'fai-GroundingCommandBarOverflowMenu__menuButton',
  menuPopover: 'fai-GroundingCommandBarOverflowMenu__menuPopover',
  menuList: 'fai-GroundingCommandBarOverflowMenu__menuList',
};

const topBottomPadding = `calc(${tokens.strokeWidthThin} + ${tokens.strokeWidthThick}) ${tokens.spacingHorizontalNone}`;

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    // Same extra height as the GroundingCommandBarTabs in order to keep height consistent
    paddingTop: topBottomPadding,
    paddingBottom: topBottomPadding,
    paddingRight: tokens.spacingHorizontalSNudge,
  },
  menuButton: {
    ...typographyStyles.body1,
  },
});

/**
 * Apply styling to the GroundingCommandBarOverflowMenu slots based on the state
 */
export const useGroundingCommandBarOverflowMenuStyles_unstable = (
  state: GroundingCommandBarOverflowMenuState,
): GroundingCommandBarOverflowMenuState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(
    GroundingCommandBarOverflowMenuClassNames.root,
    styles.root,
    state.root.className,
  );

  if (state.menuButton) {
    state.menuButton.className = mergeClasses(
      GroundingCommandBarOverflowMenuClassNames.menuButton,
      styles.menuButton,
      state.menuButton.className,
    );
  }
  if (state.menuPopover) {
    state.menuPopover.className = mergeClasses(
      GroundingCommandBarOverflowMenuClassNames.menuPopover,
      state.menuPopover.className,
    );
  }
  if (state.menuList) {
    state.menuList.className = mergeClasses(
      GroundingCommandBarOverflowMenuClassNames.menuList,
      state.menuList.className,
    );
  }

  return state;
};
